import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

const CustomDropdown = ({ 
  options,
  selectedOption,
  onChange,
  placeholder,
  minWidth,
  formatOptionLabel,
}) => {
  return (
    <Select
      options={options}
      value={selectedOption}
      onChange={onChange}
      placeholder={placeholder}
      styles={{
        control: (baseStyles) => ({
          ...baseStyles,
          backgroundColor: 'var(--eigth-color)',
          borderColor: 'var(--secondary-color)',
          borderRadius: '7px',
          color: 'white',
          minWidth,
        }),        menu: (baseStyles) => ({
          ...baseStyles,
          backgroundColor: 'var(--eigth-color)',
          zIndex: 9999,
        }),
        option: (baseStyles, state) => ({
          ...baseStyles,
          backgroundColor: state.isSelected ? 'var(--secondary-color)' : 'var(--eigth-color)',
          color: 'white',
        }),
        singleValue: (baseStyles) => ({
          ...baseStyles,
          color: 'white',
        }),
        placeholder: (baseStyles) => ({
          ...baseStyles,
          color: 'white',
        }),
        input: (baseStyles) => ({
          ...baseStyles,
          color: 'white',
        }),
      }}
      formatOptionLabel={formatOptionLabel}
    />
  );
};

CustomDropdown.propTypes = {
  options: PropTypes.array.isRequired,
  selectedOption: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  minWidth: PropTypes.number,
  formatOptionLabel: PropTypes.func,
};

export default CustomDropdown;
